import axios from "axios";
import { CONFIG_API_BE } from "../config";
import { configureSessionClient } from "./apiSession";

export default configureSessionClient(axios.create({
  baseURL: CONFIG_API_BE.API_MANAGEMENT_HOST,
  headers: { Accept: "application/json", "Content-Type": "application/json" }
}));
